/**
 * DUEL-V3-P0 (0e): the foe's tell on the body. Four stepped corner brackets round the figure in the tell colour (red
 * break, violet power, gold lock, amber guard ...), closing in as the wind-up runs out. Hard 2-px steps, 1-px dark
 * outline, no glow; the word over the head (duelRing.ts) stays.
 */
import { registerRenderPass } from './registry';
import { duelRing, tellOf } from './duelRing';
import { guardReadOwns } from './guardReadTell';
import { globeBend } from '../globe';

registerRenderPass({
  id: 'duelBodyTell',
  layer: 'labels',
  order: 108,
  draw({ mg, world: w, px: PX, iso, ox, oy }) {
    if (!duelRing.on) return;
    const e = w.get(duelRing.foe);
    if (!e || e.dead) return;
    const tell = tellOf(e, duelRing.stance[1], duelRing.broken[1], duelRing.recov[1]);
    if (!tell) return;
    if (guardReadOwns(tell.word)) return; // guard / broken: passes/guardReadTell.ts
    const [sx, sy] = iso.proj(e.x, e.y);
    const cx = (sx + ox) * PX;
    const bottom = globeBend(sx + ox, sy + oy + 2)[1] * PX;
    const top = globeBend(sx + ox, sy + oy - 46 * e.scale)[1] * PX;
    // Closes in from 1.5x the body's half width to 1x as the wind-up runs out; snapped to whole art pixels.
    const half = Math.round((16 * e.scale * (1.5 - 0.5 * tell.k) * PX) / PX) * PX;
    const arm = 6 * PX;
    const t = Math.max(2, PX);
    const pulse = Math.floor(duelRing.t * 8) % 2 === 0;
    mg.save();
    const corner = (x: number, y: number, dx: number, dy: number) => {
      for (const [col, grow] of [['rgba(12,9,14,.95)', t] as const, [`rgb(${tell.col})`, 0] as const]) {
        mg.fillStyle = col;
        const o = grow / 2;
        mg.fillRect(Math.min(x, x + dx * arm) - o, y - o, arm + grow, t + grow);
        mg.fillRect(x - o, Math.min(y, y + dy * arm) - o, t + grow, arm + grow);
      }
    };
    if (pulse || tell.k > 0.7) {
      corner(cx - half, top, 1, 1);
      corner(cx + half - t, top, -1, 1);
      corner(cx - half, bottom - t, 1, -1);
      corner(cx + half - t, bottom - t, -1, -1);
    }
    mg.restore();
  },
});
